/**修改密码 */
<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px" >
        <el-form-item label="用户名" >
            <el-input v-model="form.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码">
            <el-input v-model="form.password"></el-input>
        </el-form-item>
       
        <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">提交</el-button>
            <!-- <el-button>取消</el-button> -->
        </el-form-item>
    </el-form>
</template>

<script>
import {UpdatePwd} from '../../api/user'
export default {
    data() {
      return {
        form: {
          username: '',
          password: ''
        
        },
        // rules表单验证
        rules: {
            password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        }
      }
    },
    created() {
      this.getLoginInfo();
    },
  
    methods: {
        getLoginInfo(){
            let userinfo = JSON.parse(localStorage.getItem('userdata'));
            this.form.username = userinfo.username;
            // this.form.password = userinfo.password;
        },

      onSubmit(createData) {
        this.$refs[createData].validate(valid => {
        if (valid) {
            UpdatePwd(this.form)
            .then(res => {
              if (res.code == 0) {
                this.clearForm();
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
      },
      clearForm(){
        this.form.password = null;
      }
    },  
   

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/system/updatePwd.vue